export default "__VITE_ASSET__pw22G2kM__"